import React from 'react';
import PropTypes from 'prop-types';
import utils from "../../utils/utils";
import DATE_FORMAT from "../../components/constants/dateFormat";

const AdminEmailRow = ({email}) => {
  const dateCreated = utils.getDateFromString(email.dateCreated).format(DATE_FORMAT.displayWithTime);

  return (
    <tr>
      <th scope="row">
        {email.id}
      </th>
      <td>
        {email.subject}
      </td>
      <td>
        {email.status}
      </td>
      <td>
        {email.to.join(', ')}
      </td>
      <td>
        {email.bcc.join(', ')}
      </td>
      <td>
        {dateCreated}
      </td>
    </tr>
  );
}

AdminEmailRow.propTypes = {
  groupProjectResponse: PropTypes.object.isRequired,
};

AdminEmailRow.defaultProps = {
  groupProjectResponse: {},
};

export default AdminEmailRow;